import { render, staticRenderFns } from "./list-header.vue?vue&type=template&id=fd45c97a&"
import script from "./list-header.vue?vue&type=script&lang=js&"
export * from "./list-header.vue?vue&type=script&lang=js&"
import style0 from "./list-header.vue?vue&type=style&index=0&id=fd45c97a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports